import React, { useEffect, useState } from "react";

const LiveStreamPopup = ({ onClose, onSave, media }) => {
    const [name, setName] = useState("");
    const [streamUrl, setStreamUrl] = useState("");
    const [streamType, setStreamType] = useState("HLS");
    const [duration, setDuration] = useState(0);
    const [autoPlay, setAutoPlay] = useState(true);
    const [mute, setMute] = useState(true);
    const [fitMode, setFitMode] = useState("contain");
    const [showControls, setShowControls] = useState(false);

    useEffect(() => {
        if (media) {
            setName(media.name);
            setStreamUrl(media.url);
            setDuration(media.duration || 0);

            setStreamType(media.streamType || "HLS");
            setAutoPlay(media.autoPlay ?? true);
            setMute(media.mute ?? true);
            setFitMode(media.fitMode || "contain");
            setShowControls(media.showControls ?? false);
        }
    }, [media]);

    const handleSave = () => {

        onSave({
            id: media?.id || null,
            name,
            url: streamUrl,
            duration,
            streamType,
            autoPlay,
            mute,
            fitMode,
            showControls
        });

    };

    return (
        <div className="popup-overlay">
            <div className="popup-content" style={{ width: "650px" }}>
                <h2>{media ? "Edit Live Stream" : "Add Live Stream"}</h2>

                <div className="form-group">
                    <label>Name</label>
                    <input
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Live Stream URL</label>
                    <input
                        className="form-control"
                        value={streamUrl}
                        placeholder="https://example.com/live.m3u8"
                        onChange={(e) => setStreamUrl(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Stream Type</label>

                    <select
                        className="form-control"
                        value={streamType}
                        onChange={(e) => setStreamType(e.target.value)}
                    >
                        <option value="HLS">HLS (.m3u8)</option>
                        <option value="DASH">MPEG DASH (.mpd)</option>
                        <option value="RTSP">RTSP</option>
                        <option value="YouTube">YouTube Live</option>
                        <option value="Generic">Generic URL</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Duration (0 = Until Layout Changes)</label>

                    <input
                        type="number"
                        className="form-control"
                        value={duration}
                        onChange={(e) => setDuration(parseInt(e.target.value))}
                    />
                </div>

                <div className="form-group">
                    <label>Fit Mode</label>

                    <select
                        className="form-control"
                        value={fitMode}
                        onChange={(e) => setFitMode(e.target.value)}
                    >
                        <option value="contain">Contain</option>
                        <option value="cover">Cover</option>
                        <option value="fill">Stretch</option>
                    </select>
                </div>

                <div className="form-group">

                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={autoPlay}
                            onChange={(e) => setAutoPlay(e.target.checked)}
                        />

                        <label className="form-check-label">
                            Auto Play
                        </label>
                    </div>

                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={mute}
                            onChange={(e) => setMute(e.target.checked)}
                        />

                        <label className="form-check-label">
                            Mute Audio
                        </label>
                    </div>

                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={showControls}
                            onChange={(e) => setShowControls(e.target.checked)}
                        />

                        <label className="form-check-label">
                            Show Controls
                        </label>
                    </div>

                </div>

                <div className="form-buttons">
                    <button className="btn btn-success" onClick={handleSave}>
                        Save
                    </button>

                    &nbsp;

                    <button className="btn btn-primary" onClick={onClose}>
                        Cancel
                    </button>
                </div>

            </div>
        </div>
    );
};

export default LiveStreamPopup;